module.exports = __webpack_public_path__ + "img/bft.f1987a69.png";